<template>
  <div class="report-fs">
    <div style="margin-top: 178px;" v-if="pathLogo == m"></div>
    <div style="margin-top: 35px;" v-if="pathLogo != m"></div>
    <!-- <div class="mlogo t-alignlogo">
        <img class="wlogo" :src="pathLogo" />
      </div> -->
    <h3 class="text-center fs-head-co">{{ name }}</h3>
    <h3 class="text-center fs-head-co">{{ desc }}</h3>


    <md-card-content dir="rtl" class="redirect-dir">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card>
            <md-card-header style=" margin-bottom: 30px;" class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title">تقرير الإجازات <span>نوع {{ vacationName }} </span> <span>لسنة {{ vacationYear
                    }}</span></h4>
              </div>
            </md-card-header>

            <div style="margin-top: 10px; margin-bottom: 35px; " class="marginTop">
              <md-card-content>


                <md-table class="paginated-table table-striped table-hover mt-25">
                  <md-table-row>


                    <md-table-cell class="border-staffLists">ر.م</md-table-cell>

                    <md-table-cell class=" border-staffLists">الاسم</md-table-cell>


                    <md-table-cell class="border-staffLists">الرقم الوظيفي</md-table-cell>

                    <md-table-cell class="border-staffLists">الأيام</md-table-cell>


                  </md-table-row>
                  <md-table-row v-for="(item, i) in data" :key="i">

                    <md-table-cell class="border-staffLists" md-label="الصنف">{{
      i + 1
    }}</md-table-cell>

                    <md-table-cell class="  border-staffLists" md-label="الصنف">{{
        item.employeeName
      }}</md-table-cell>

                    <md-table-cell class=" border-staffLists " md-label="الصنف">{{
        item.jobNumber
      }}</md-table-cell>


                    <md-table-cell class="border-staffLists" md-label="الصنف">{{
                      item.vacationDays
                      }}</md-table-cell>

                  </md-table-row>
                </md-table>

              </md-card-content>
            </div>

          </md-card>
        </div>

      </div>
    </md-card-content>


  </div>
</template>

<script>
//  import { count } from "console";
import env from "../../../env";

export default {
  mounted() { },
  props: ["name", "desc", "data", "pathLogo", "vacationYear", "vacationName", "vacationYear"],
  data() {
    return {
      currentSort: "",
      currentSortOrder: "asc",
      m: env.mTop(),

    };
  },
  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return (
          d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) { }
    },
    convertToUi(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return " - ";
        }
        return (
          d.getDate() + " - " + (d.getMonth() + 1) + " - " + d.getFullYear()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) { }
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
  },
};
</script>

<!-- <style lang="scss" scoped>
  @import "../../assets/css/StaffLists";
  
  .report-fs {
    * {
      font-size: 22px !important;
      font-family: "Cairo", sans-serif !important;
    }
  
    .md-table-head {
      .md-table-head-container {
        .md-table-head-label {
          font-size: 22px !important;
        }
      }
    }
  
    .fs-head-co {
      font-size: 29px !important;
      font-weight: bold;
    }
  
    .fs-head {
      font-size: 25px !important;
    }
  
    .custom-mt {
      margin-bottom: 440px;
    }
  
    .border-staffLists {
      border: 1px solid #000;
      /* border-left: none; */
      border-top: 1px solid #000 !important;
      height: 90px;
    }
  
  
  }
  </style> -->